import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnarchiv: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="unarchiv, unbox"><path d="M9.25 2.75L3.75 6.75V20.25H20.25V6.75L14.75 2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 11.25H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.24799 6.75H19.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconUnarchiv;
